/* Edits the state whenever revision event triggers */

export function revisionFetchHasErrored(state = false, action) {
	switch (action.type) {
	case 'REVISION_LOAD_FAILED':
		return action.hasErrored;
	default:
		return state;
	}
}
export function revisionFetchIsLoading(state = false, action) {
	switch (action.type) {
	case 'REVISION_ISLOADING':
		return action.isLoading;
	default:
		return state;
	}
}
export function revision(state = [], action) {
	switch (action.type) {
	case 'REVISION_LOADED':
		return action.revision;
	default:
		return state;
	}
}
